/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Office_Model_FranchiseeInputs */

const cs_office_model_franchisee = /** @type {(inputs: Office_Model_FranchiseeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franšízant`)
};

const en_office_model_franchisee = /** @type {(inputs: Office_Model_FranchiseeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchisee`)
};

/**
* | output |
* | --- |
* | "Franchisee" |
*
* @param {Office_Model_FranchiseeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const office_model_franchisee = /** @type {((inputs?: Office_Model_FranchiseeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Office_Model_FranchiseeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_office_model_franchisee(inputs)
	return cs_office_model_franchisee(inputs)
});